import { useState, useEffect } from "react";

export default function GroupOverview() {
  const [groups, setGroups] = useState([]);
  const [members, setMembers] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]);

  useEffect(() => {
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_groups")
      .then(res => res.json())
      .then(setGroups);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_members")
      .then(res => res.json())
      .then(setMembers);
    fetch(process.env.REACT_APP_BACKEND_URL+"/report_groups_members")
      .then(res => res.json())
      .then(setGroupMembers);
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Kontaktpersonu grupu pārskats</h2>
      {groups.map(group => {
        const memberIds = groupMembers.filter(gm => gm.group_id === group.id).map(gm => gm.member_id);
        const groupMemberDetails = members.filter(m => memberIds.includes(m.id));
        return (
          <div key={group.id} className="mb-6 border p-4 rounded shadow">
            <h3 className="text-xl font-semibold">{group.name}</h3>
            <p>Status: {group.is_active ? "Aktīva" : "Neaktīva"}</p>
            <ul className="mt-2">
              {groupMemberDetails.length ? groupMemberDetails.map(m => (
                <li key={m.id}>{m.name} {m.surname} ({m.phone_number})</li>
              )) : <li>Šajā grupā nav kontaktpersonu</li>}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
